export function getBrowserFingerprint(): string {
  const nav = navigator as Navigator & {
    hardwareConcurrency?: number;
    deviceMemory?: number;
  };

  // Собираем ключевые данные браузера
  const navigatorInfo = [
    nav.userAgent,
    nav.language,
    nav.platform,
    nav.hardwareConcurrency?.toString() ?? '',
    nav.deviceMemory?.toString() ?? '',
  ].join('::');

  // Собираем данные экрана
  const screenInfo = [
    screen.width.toString(),
    screen.height.toString(),
    screen.colorDepth.toString(),
  ].join('x');

  // Часовой пояс
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Финальная строка
  const fpString = [navigatorInfo, screenInfo, timezone].join('||');

  // Хеширование fingerprint строки (простое, для примера)
  let hash = 0;
  for (let i = 0; i < fpString.length; i++) {
    const chr = fpString.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0; // Приводим к 32-битному int
  }
  return 'fp_' + Math.abs(hash).toString(16);
}